var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCSRFToken } from './xhr';
export const getBaseFetchHeaders = () => ({
    'X-CSRF-Token': getCSRFToken(),
});
export const getJSONHeaders = () => (Object.assign(Object.assign({}, getBaseFetchHeaders()), { 'Content-Type': 'application/json' }));
export const handleResponseError = (res) => {
    if (!res.ok) {
        throw new Error(res.statusText);
    }
};
export function handleJSONResponse(res) {
    return __awaiter(this, void 0, void 0, function* () {
        handleResponseError(res);
        return (yield res.json());
    });
}
